import { Component, OnInit,Inject,ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import { SurveyStatusV2Service } from "../../../survey-status-v2.service";
import Swal from 'sweetalert2';
import * as correosPrueba from './prueba';
const moment = require('moment');
const momentTz = require('moment-timezone');
import * as $ from 'jquery';
import { fuseAnimations } from '@fuse/animations';
import { zonasUTC } from 'app/main/pagina/zonasUtc';
@Component({
  selector: 'app-modales',
  templateUrl: './modales.component.html',
  styleUrls: ['./modales.component.scss'],
  animations : fuseAnimations
})
export class ModalesComponent implements OnInit {
  @ViewChild('editorMce') editorMce: any;
  idiomaActual:string;

  logEstatus:any[] = [];
  logEmailsPreview:any[] = [];
  openCorreo= [
    {
      opened:"Opened",
      fecha: "11/12/2021",
      detalles:'lo recibio bien 1',
    },
    {
      opened:"Opened",
      fecha: "12/12/2021",
      detalles:'lo recibio bien 2',
    },
    {
      opened:"Opened",
      fecha: "13/12/2021",
      detalles:'lo recibio bien 3',
    },
    {
      opened:"Opened",
      fecha: "14/12/2021",
      detalles:'lo recibio bien 4',
    }];

    emailHistori:any="";
    emailData:any="";
    opciones: any = {
      menubar: false,
      plugins: 'autoresize print preview paste importcss searchreplace autolink save directionality code visualblocks visualchars fullscreen link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount image textpattern noneditable help charmap quickbars emoticons',
      toolbar: 'undo redo | bold italic underline strikethrough | fontsizeselect | table | \
                alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | \
                forecolor backcolor removeformat | charmap emoticons | fullscreen  preview | \
                link codesample image | ltr rtl',
      toolbar_sticky: true,
      // height: 250,
      toolbar_mode: 'sliding',
      setup: function (editor) {
	    editor.setMode("readonly")
	}
      // language: 'en_US'
    };

    mostrarMas:boolean=false;
    mostrarMasDefere:boolean=false;
    panelOpenState = false;
    cargandoInfoGral = true;
    cargandoLogStatus = true;
    cargandoLogEmail = true;
    cargandoInfoEmail:boolean;
    cargandoInfoPreviewEmail:boolean;
    nameTipoIconEmail:string;
    indexAnterior:number;
    indexAnteriorEmail:number;
    openDetailsInfo:string;
    eventData:any[]=[];
    eventDropped:any[]=[];
    eventProcessed:any[]=[];
    eventDelivered:any[]=[];
    eventBounce:any[]=[];
    eventOpen:any[]=[];
    eventDeferred:any[]=[];
    uiltimoEventDeferred:any;

 offsetPipe: string;
 diferenciaUtc: number;
 zonasUTC = zonasUTC;
 indiceZona: number;
    constructor(
      @Inject(MAT_DIALOG_DATA) public datos: any,
      private translateSrv: TranslateService,
      private surveyServ: SurveyStatusV2Service
    ) {
    this.idiomaActual = this.translateSrv.currentLang;
  }

    ngOnInit(): void {
      console.log('datos',this.datos);
      if (this.datos.statusCorreo=="delivered") {
        this.nameTipoIconEmail="mark_email_read";
      }else if (this.datos.statusCorreo=="notDelivered") {
        this.nameTipoIconEmail="unsubscribe";
      }else if (this.datos.statusCorreo=="processing") {
        this.nameTipoIconEmail="forward_to_inbox";
      }
      // this.getInfoEmailEstatus();
      this.getLogStatusEmailColaboradores();
      this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == 1);
      this.calculoOffsetPipe();
    }

    calculoOffsetPipe(){
      this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
      console.log("diferenciaUtc:",this.diferenciaUtc);
      let horas = this.diferenciaUtc / 60;
      if(horas < 0){
        horas = horas * -1;
        if(horas < 10){
          this.offsetPipe = "-0" + horas + "00";
        }
        else{
          this.offsetPipe = "-" + horas + "00";
        }
      }
      else{
        if(horas < 10){
          this.offsetPipe = "+0" + horas + "00";
        }
        else{
          this.offsetPipe = "+" + horas + "00";
        }
      }
      console.log("offsetPipe:",this.offsetPipe);
    }

    infoEmail(index,info){
      this.cargandoInfoEmail=true;
      this.mostrarMas=false;
      console.log('index Nuevo',index);
      console.log('indexAnterior',this.indexAnterior);
      if (this.indexAnterior==undefined) {
        this.eventProcessed=[];
        this.eventDelivered=[];
        this.eventOpen=[];
        this.eventBounce=[];
        this.eventDropped=[];
        this.eventDeferred=[];
        console.log('es la primera vez ');
        this.indexAnterior=index;
        this.emailHistori=this.logEstatus[index];
        this.logEstatus[index].activo=true;
        console.log('this.emailHistori',this.emailHistori);
        console.log('logEstatus',this.logEstatus);
        this.getEventsXEmailMessageID(this.emailHistori);
      }else {
        console.log("es la segunda vez o tercera o mas ");
        if (index!=this.indexAnterior) {
          this.eventProcessed=[];
          this.eventDelivered=[];
          this.eventOpen=[];
          this.eventBounce=[];
          this.eventDeferred=[];
          this.eventDropped=[];
          this.logEstatus[this.indexAnterior].activo=false;
          this.indexAnterior=index;
          this.logEstatus[index].activo=true;
          this.emailHistori=this.logEstatus[index];
          this.getEventsXEmailMessageID(this.emailHistori);
        }else if (index==this.indexAnterior) {
          this.indexAnterior=index;
          this.emailHistori=this.logEstatus[index];
          this.logEstatus[index].activo=true;
          this.cargandoInfoEmail=false;

        }
      }

    }
    //
    // getInfoEmailEstatus(){
    //   let datos={
    //     productoId:this.datos.productoId,
    //     tipo:this.datos.tipoCorreo,
    //     colaboradorId:this.datos.datosColaborador.colaboradorId,
    //     status:this.datos.statusCorreo,
    //   }
    //   this.surveyServ.getInfoEmailStatus(datos).subscribe((respuesta:any)=>{
    //     console.log('respuesta correos filtardos ',respuesta);
    //     if (respuesta.success) {
    //
    //       this.logEstatus=respuesta.logEstatus;
    //       this.logEmailsPreview=respuesta.dataEmails;
    //       this.logEstatus.forEach(element => {
    //         element.activo=false;
    //       });
    //       this.logEmailsPreview.forEach(element => {
    //         element.activo=false;
    //       });
    //       this.cargandoLogStatus=false;
    //
    //
    //       console.log("this.logEstatus",this.logEstatus)
    //       console.log("this.logEmailsPreview",this.logEmailsPreview)
    //     }
    //
    //   })
    // }

    getLogStatusEmailColaboradores(){
      let datos={
        productoId:this.datos.productoId,
        tipo:this.datos.tipoCorreo,
        colaboradorId:this.datos.datosColaborador.ColaboradorID,
        status:this.datos.statusCorreo,
      }
      this.surveyServ.getLogStatusEmailColab(datos).subscribe((respuesta:any)=>{
        console.log('respuesta nuevo servico correos filtardos ',respuesta);
        if (respuesta.success) {

          this.logEstatus=respuesta.logEstatus;
          this.logEmailsPreview=respuesta.dataEmails;
          this.logEstatus.forEach(element => {
            element.activo=false;
          });
          this.logEmailsPreview.forEach(element => {
            element.activo=false;
          });
          this.cargandoLogStatus=false;


          console.log("this.logEstatus",this.logEstatus)
          console.log("this.logEmailsPreview",this.logEmailsPreview)
        }

      })
    }

    getEventsXEmailMessageID(infoEmailEvent){
      console.log('infoEmailEvent',infoEmailEvent);
      this.surveyServ.getEventsXEmailMessageId(this.datos.productoId,this.datos.tipoCorreo,infoEmailEvent.to,infoEmailEvent.sg_message_id ).subscribe((respuesta:any)=>{
        console.log('respuesta correos filtardos ',respuesta);
        if (respuesta.success) {
          this.cargandoInfoEmail=false;
          this.eventData=respuesta.eventData;
          this.eventData.forEach((tipoEvent) => {
            var dateString = moment.unix(tipoEvent.Timestamp);
            tipoEvent.fechaActualNueva=dateString;
            if (tipoEvent.Event=="processed") {
              this.eventProcessed.push(tipoEvent)
            }
            if (tipoEvent.Event=="delivered") {
              this.eventDelivered.push(tipoEvent);
            }
            if (tipoEvent.Event=="open") {
              this.eventOpen.push(tipoEvent);
            }
            if (tipoEvent.Event=="bounce") {
              this.eventBounce.push(tipoEvent);
            }
            if (tipoEvent.Event=="dropped") {
              this.eventDropped.push(tipoEvent);
            }
            if (tipoEvent.Event=="deferred") {
              this.eventDeferred.push(tipoEvent);
            }
          });
          console.log('eventProcessed',this.eventProcessed);
          console.log('eventDelivered',this.eventDelivered);
          console.log('eventOpen',this.eventOpen);
          console.log('Bounce',this.eventBounce);
          console.log('eventDropped',this.eventDropped);
          console.log('eventDeferred',this.eventDeferred);
this.uiltimoEventDeferred=this.eventDeferred.pop();
console.log('ultimoElement',this.uiltimoEventDeferred);

        }

      })
    }

    verDatosInformation(){
      if (!this.mostrarMas) {
        this.mostrarMas=true;
      }else{
        this.mostrarMas=false;
      }
    }
    vermostrarMasDefere(){
      if (!this.mostrarMasDefere) {
        this.mostrarMasDefere=true;
      }else{
        this.mostrarMasDefere=false;
      }
    }

    openActivity(index){
      this.openDetailsInfo=this.eventOpen[index].sg_message_id;
    }

    infoPreviewEmail(index,info){
      this.cargandoInfoPreviewEmail=true;

      console.log('index Nuevo',index);
      console.log('indexAnteriorEmail',this.indexAnteriorEmail);
      if (this.indexAnteriorEmail==undefined) {
        console.log('es la primera vez ');
        this.indexAnteriorEmail=index;
        this.emailData=this.logEmailsPreview[index];
        this.logEmailsPreview[index].activo=true;
        console.log('this.emailData',this.emailData);
        console.log('logEmailsPreview',this.logEmailsPreview);
        setTimeout(() => {
          this.cargandoInfoPreviewEmail=false;
        }, 2000);
        // this.getEventsXEmailMessageID(this.emailData);
      }else {
        console.log("es la segunda vez o tercera o mas ");
        if (index!=this.indexAnteriorEmail) {
          this.logEmailsPreview[this.indexAnteriorEmail].activo=false;
          this.indexAnteriorEmail=index;
          this.logEmailsPreview[index].activo=true;
          this.emailData=this.logEmailsPreview[index];
          setTimeout(() => {
            this.cargandoInfoPreviewEmail=false;
          }, 2000);
          // this.getEventsXEmailMessageID(this.emailData);
        }else if (index==this.indexAnteriorEmail) {
          this.indexAnteriorEmail=index;
          this.emailData=this.logEmailsPreview[index];
          this.logEmailsPreview[index].activo=true;
          this.cargandoInfoPreviewEmail=false;

        }
      }

      let esperaImg = setInterval(function () {
        if($(".tox-notifications-container").length && $(".tox-statusbar__branding")){
          $(".tox-notifications-container").hide();
          $(".tox-statusbar__branding").hide();
          // this.editorMce._editor.setMode("readonly");
          clearInterval(esperaImg);
        }
      }, 0);

    }


  }
